$(function () {
    $(document).on('click', '.navmeun-btnright', function (event) {
        $('.navlist').slideUp();
        $('.navmeun-btnup').addClass('navmeun-btnright');
        $('.navmeun-btnup').removeClass('navmeun-btnup');

        $('.left-nav > .nav-active').removeClass('nav-active');
        $(this).parent().parent().addClass('nav-active');

        $(this).removeClass('navmeun-btnright');
        $(this).addClass('navmeun-btnup');

        if ($(this).parent().nextAll('ul').css('display') != 'block') {
            $(this).parent().nextAll('ul').slideDown();
        }
    });

    $(document).on('click', '.navmeun-btnup', function (event) {
        $(this).removeClass('navmeun-btnup');
        $(this).addClass('navmeun-btnright');

        if ($(this).parent().nextAll('ul').css('display') == 'block') {
            $(this).parent().nextAll('ul').slideUp();
        }
    });

    $(document).on('click', '.navmeun-title', function (event) {
        $(this).next('.navmeun-btn').click();
    });

    recalcLeftHeight();
});

window.onresize = function (event) {
    recalcLeftHeight();
};

window.onscroll = function (event) {
    recalcLeftHeight();
};

function recalcLeftHeight() {
    var height = $('.right').css('height');
    $('.left').css('height', height);
}